module.exports = __webpack_public_path__ + "img/icon.twitter.6847e2d2.svg";